import type {
  TypeArticleWithoutUnresolvableLinksResponse,
  TypeEventWithoutUnresolvableLinksResponse,
  TypePageBuilderWithoutUnresolvableLinksResponse,
  TypeProductDetailsPageWithoutUnresolvableLinksResponse,
} from '~/types/contentful'

export const getPageMetaData = (
  pageData:
    | TypeArticleWithoutUnresolvableLinksResponse
    | TypeEventWithoutUnresolvableLinksResponse
    | TypePageBuilderWithoutUnresolvableLinksResponse
    | TypeProductDetailsPageWithoutUnresolvableLinksResponse,
  pageType: 'website' | 'article' = 'website',
) => {
  const { localizedStrings } = useLocalizedStrings()
  const route = useRoute()

  const { metaTitle, metaDescription, metaImage } = pageData?.fields || {}
  const metaImageType = (metaImage?.fields?.file?.contentType ||
    'image/jpeg') as 'image/jpeg' | 'image/gif' | 'image/png'

  const titleSuffix = localizedStrings.value['wpn'] || 'WPN'
  const concatenatedMetaTitle = metaTitle
    ? `${metaTitle} | ${titleSuffix}`
    : titleSuffix

  const globalStore = useGlobalStore()

  useSeoMeta({
    description: metaDescription,
    title: concatenatedMetaTitle,
    // Open Graph
    ogDescription: metaDescription,
    ogImage: {
      height: metaImage?.fields?.file?.details?.image?.height,
      type: metaImageType,
      url: metaImage?.fields?.file?.url || '',
      width: metaImage?.fields?.file?.details?.image?.width,
    },
    ogSiteName: globalStore.siteMeta?.metaSiteName,
    ogTitle: concatenatedMetaTitle,
    ogType: pageType,
    ogUrl: globalStore.siteMeta?.metaUrl + route?.fullPath,
    // Twitter
    twitterCard: 'summary_large_image',
    twitterDescription: metaDescription,
    twitterImage: metaImage?.fields?.file?.url || '',
    twitterSite: '@Wizards_DnD',
    twitterTitle: concatenatedMetaTitle,
  })
}
